
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 15.298L3.552 6.752a.902.902 0 00-1.286 0 .927.927 0 000 1.3l9.092 9.196a.904.904 0 001.285 0l9.091-9.195a.922.922 0 00.266-.65.922.922 0 00-.266-.65.902.902 0 00-1.286 0L12 15.297z","fill":"currentColor"}})])
          )
        }
      }
    